/** Abort in-flight PO / WhatsApp Gemini fetches when the user leaves the page. */

const activeControllers = new Set<AbortController>();
let unloadHookInstalled = false;

export function registerExtractAbortController(controller: AbortController): void {
  activeControllers.add(controller);
  installUnloadHook();
}

export function unregisterExtractAbortController(controller: AbortController): void {
  activeControllers.delete(controller);
}

export function cancelAllExtractRequests(): void {
  for (const controller of activeControllers) {
    controller.abort();
  }
  activeControllers.clear();
}

function installUnloadHook(): void {
  if (unloadHookInstalled || typeof window === 'undefined') return;
  unloadHookInstalled = true;
  window.addEventListener('pagehide', cancelAllExtractRequests);
  window.addEventListener('beforeunload', cancelAllExtractRequests);
}
